import { Controller } from "@hotwired/stimulus"

// Below 640px the filter fields live behind a "Filters" button. Above it they
// are always shown and this controller does nothing — the layout is CSS, and
// only the small-screen disclosure needs behaviour.
export default class extends Controller {
  static targets = ["fields", "toggle"]

  toggle() {
    const open = this.toggleTarget.getAttribute("aria-expanded") === "true"
    this.fieldsTarget.classList.toggle("hidden", open)
    this.fieldsTarget.classList.toggle("flex", !open)
    this.toggleTarget.setAttribute("aria-expanded", String(!open))
  }

  // Changing the sort select submits straight away: an Apply button beside a
  // control that has only one possible next step is a step for its own sake.
  submit(event) {
    event.target.form.requestSubmit()
  }
}
